import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { Component, OnDestroy, NgZone, OnInit, ViewChild, inject, Input, Output, EventEmitter } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep, debounce, filter } from 'lodash-es';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { MessageService } from 'primeng/api';
import { firstValueFrom, map, Subscription, take } from 'rxjs';
import { GlobalConstants } from 'src/app/base/global.constants';
import { nodeType } from 'src/app/pages/designs/data-model/data-model.component';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { UtilService } from 'src/app/services/util.service';
import { fsLoginInitiated, metaInfo } from 'src/app/STORE/selectors/applifecycle.selector';
import { environment } from 'src/environments/environment';
import { ApiConstants } from 'src/app/base/api-constants';
import { FsBaseService } from 'src/app/services/fs-base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  acceptAiDataModel,
  generateModelForFieldPrompt,
  generateModelForTablePrompt,
  rejectAiDataModel,
  updateAIDM,
  updateAIDMFail,
  updateAIDMSuccess
} from 'src/app/STORE/actions/aiapplicationdatamodel.actions';
import {
  rejectSuccessData,
  aiDMSuccData,
  aiDMFailData,
  rejectFailureData,
  generateModelForTablePromptSuccData,
  generateModelForTablePromptFailData,
  generateModelForFieldPromptSuccData,
  generateModelForFieldPromptFailData
} from 'src/app/STORE/selectors/aiapplicationdatamodel.selector';
import { PanZoom } from 'panzoom';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { PreValidationTblViewComponent } from '../pre-validation-tbl-view/pre-validation-tbl-view.component';
import { GenerationSelectors } from 'src/app/STORE/selectors/generations/generation.selectors';
import ScreenInterimActions from 'src/app/STORE/actions/generations/screen-interim.actions';
import { allInterimScreens } from 'src/app/STORE/selectors/generations/screen-interim.selectors';
import { GenerationActions } from 'src/app/STORE/actions/generations/generation.actions';
import { GenerationStepCapitals, GenerationStepStatus } from '../generations-wizard/types';
import { v4 as uuidv4 } from 'uuid';

interface UploadHistoryData {
  appId: string;
  generateDatamodelPercent: number;
  generateDatamodelStage: string;
  uploadId: string;
  generateDatamodelErrorMsg: string[];
}

export enum AiGenerationType {
  IMPORT,
  PROMPT,
  FIELD
}

@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-schema-to-data-model',
  templateUrl: './schema-to-data-model.component.html',
  styleUrls: ['./schema-to-data-model.component.scss'],
  standalone: false //NOSONAR
})
export class SchemaToDataModelComponent implements OnInit, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private dialogRef = inject(DynamicDialogRef, { optional: true });
  private util = inject(UtilService);
  private zone = inject(NgZone);
  private translate = inject(TranslateService);
  appGlobalService = inject(AppGlobalService);
  private messageService = inject(MessageService);
  private store = inject(Store);
  private fsService = inject(FsBaseService);
  private http = inject(HttpClient);
  private baseService = inject(HttpBaseService);
  private dialogService = inject(DialogService, { optional: true });
  private config = inject(DynamicDialogConfig, { optional: true });

  @ViewChild('visualizerDiv')
  mermaidDiv;

  isVisualizerVisible = false;
  acceptConfirmation = false;
  pageGenRequired = true;
  confirmationMessage = '';
  PageConfirmationMessage = '';
  allowCreationOfPages = true;
  zoomElement: PanZoom;
  tableTitles: any = [];
  tableMap = {};
  tableFieldMap = {};
  fieldTitles: any = {};
  activeNode: any;
  prevActiveNode: any;
  curNodeData: any = null;
  disallowEdit = false;
  messages: any = [];
  waitingNode = null;
  rowid = null;
  dataModelDataOrder: any = [];
  fsData: any = [];
  appId = '';
  orgId = '';
  tabId = '';
  isLoading = false;
  propertyLoading = false;
  selectedNodeTitle: any = null;
  selectedNodeType = null;
  showPropPane = false;
  selectedNode = null;
  debounceTime = 1000;
  selectedRow: any;
  unSubHistoryList: any = [];
  unSubDMList: any = [];
  uploadId: any = null;
  initialCall = false;
  subscriptions: Subscription[] = [];
  searchTerm: any = '';
  filter: any;
  public panelSizes = [30, 70];
  availableTables: any = [];
  dataTypes = [
    {
      name: 'filter',
      value: 'filter',
      class: 'form-control',
      isFilter: true
    },
    {
      name: '-----------------',
      value: '',
      class: 'type-separator',
      isDivider: true
    },
    {
      name: 'String',
      value: 'String',
      class: ''
    },
    {
      name: 'Number',
      value: 'Number',
      class: ''
    },
    {
      name: 'Drop Down',
      value: 'Dropdown',
      class: ''
    },
    {
      name: 'Date Time',
      value: 'DateTime',
      class: ''
    },
    {
      name: 'Boolean',
      value: 'Boolean',
      class: ''
    },
    {
      name: 'Text',
      value: 'Text',
      class: ''
    },
    {
      name: '-----------------',
      value: '',
      class: 'type-separator',
      isDivider: true
    },
    {
      name: 'CheckBox',
      value: 'Checkbox',
      class: ''
    },
    {
      name: 'Currency',
      value: 'Currency',
      class: ''
    },
    {
      name: 'Date Only',
      value: 'Date',
      class: ''
    },
    {
      name: 'Double',
      value: 'Double',
      class: ''
    },
    {
      name: 'Email',
      value: 'Email',
      class: ''
    },
    {
      name: 'File Attachment',
      value: 'File Attachments',
      class: ''
    },
    {
      name: 'Image Carousel',
      value: 'Image Carousel',
      class: ''
    },
    {
      name: 'Radio Button',
      value: 'Radio',
      class: ''
    },
    {
      name: 'URL',
      value: 'URL',
      class: ''
    },
    {
      name: 'Yes No',
      value: 'Yes No',
      class: ''
    },
    {
      name: 'Color',
      value: 'Color',
      class: ''
    },
    {
      name: 'Auto Number',
      value: 'Auto-number',
      class: ''
    },
    {
      name: '-----------------',
      value: '',
      class: 'type-separator',
      isDivider: true
    }
  ];
  sysGenFields = ['sid', 'created by', 'modified by', 'created date', 'modified date', 'isactive', 'sync time'];
  @ViewChild('dataTypeOp')
  public dataTypeOp;
  @ViewChild('uploadOp')
  public uploadOp;
  @ViewChild('schemaSplitter')
  public splitter;
  attachmentLoader = false;
  uploadedFiles: any[] = [];
  myfile: any = [];
  @ViewChild('fileupload') fileUpload: any;
  aiDataModelGenerationInprogress = false;
  isDataModelReadyToMerge = false;
  isUploadActive = false;
  lastestUploadData: UploadHistoryData | null;
  uploadProgress: any = 0;
  errPopup = false;
  propertyPaneData;
  intialSchemaLoad = true;
  showLogs = false;
  importStatus: any = 'GEN_IN_PROGRESS';
  uploadProgressUpdateInterval;
  triggerImport = false;
  selectedFileType: any;
  menuItems: any = [];
  acceptedFileTypes = '';
  importDialogHeader = '';
  aiGenerationType: AiGenerationType | null;
  isImportDialogVisible = false;
  isPromptSectionVisible = false;
  promptText = '';
  metaInfoMap: any;
  metaInfoSub$: Subscription;
  data: any;

  @Input()
  renderInsideModernizeMenu = false; // render only if inside reverse engineerin data model
  @Input()
  isStepReadOnly = false;
  @Output()
  dataModelCountChange = new EventEmitter<number>();
  @Input()
  workflowAssociated = false;
  interimScreens: any[] = [];

  constructor() {
    if (this.config) {
      this.data = this.config?.data;
    } else {
      this.data = {};
    }
  }
  tableAndFieldDataMap = {};

  cancelUpload() {
    this.uploadOp.hide();
    this.myfile = [];
  }

  public onSelectImage(evt: any) {
    // Error messages related to maxSize and invalid file types are handled by p-fileupload
    let addFlag = true;
    for (let i = 0; i < evt.files?.length; i++) {
      if (evt.files[0]?.size > 5242880) {
        addFlag = false;
        this.myfile = [];
      }
      const fileExtension = evt.files[0]?.name.split('.').pop();
      if (!this.acceptedFileTypes.includes(fileExtension)) {
        addFlag = false;
        this.myfile = [];
      }
      if (addFlag) {
        this.myfile = [evt.files[i]];
      }
    }
  }

  /**
   * Generates a schema from the uploaded file. If `afterReject` is true or there is no latest upload data,
   * it sends a POST request to the server to generate the schema. Otherwise, it rejects the data model.
   *
   * @param {boolean} [afterReject] - Optional parameter to indicate if the schema generation is triggered after a rejection.
   */
  generateSchema(afterReject?) {
    if (!this.lastestUploadData || afterReject) {
      const options = {
        headers: new HttpHeaders({
          'x-rappit-application': this.appGlobalService.get('appId'), // same hearders added in upload service also
          'x-rappit-organization': this.appGlobalService.get('orgId')
        })
      };
      const url = `${environment.apihost}/ai-datamodel/generate-model-from-file/${this.selectedFileType}/${this.orgId}/${this.appId}`;
      const formData = new FormData();
      formData.append('files', this.myfile[0]);
      this.triggerImport = true;
      this.selectedFileType = '';
      this.acceptedFileTypes = '';
      this.http.post(url, formData, options).subscribe(
        (data: any) => {
          this.myfile = [];
        },
        (err) => {
          this.aiDataModelGenerationInprogress = false;
          this.myfile = [];
        }
      );
      this.aiDataModelGenerationInprogress = true;
    } else if (this.dataModelDataOrder.length) {
      this.rejectDataModel('GEN_AI_REUPLOAD_DATA_MODEL_CONF_MSG', this.generateSchema, true);
    } else {
      this.rejectDataModelImpl(this.generateSchema, true);
    }
  }

  reArrangeLegforGenFieldsAtBottom(ftNode) {
    let nodeNum;
    // Include Pid (parent reference field) as a connectable field even though it's sysGen
    const condition = (element) => !element?.data.sysGen || element?.data.name === 'Pid';
    const lastChild = ftNode?.children[ftNode?.children?.length - 1];
    // Check if last child is sysGen but NOT Pid (Pid should be connected)
    if (lastChild?.data?.sysGen && lastChild?.data?.name !== 'Pid') {
      const childArray: any[] = [...(ftNode?.children ?? {})];
      for (let i = childArray.length - 1; i >= 0; i--) {
        if (condition(childArray[i])) {
          nodeNum = i;
          return nodeNum;
        }
      }
    } else {
      nodeNum = ftNode?.children.length - 1;
    }
    return nodeNum;
  }

  /**
   * Rearranges the tree leg indicator for elements with the class `fancytree-folder`.
   * This function uses a timeout to delay the rearrangement process.
   *
   * @param {number} [timeout=0] - The delay in milliseconds before the rearrangement process starts.
   *
   * The function iterates over each element with the class `fancytree-folder` and performs the following:
   * - Finds the vertical line element within the folder.
   * - Checks if the folder node has children and is expanded.
   * - If the folder node has children and is expanded, it finds the link node and its horizontal line.
   * - Adjusts the height of the vertical line to match the position of the horizontal line.
   * - If the folder node does not have children or is not expanded, it hides the vertical line.
   */
  rearrageTreeLegIndicator(timeout = 0) {
    setTimeout(() => {
      $('#schemaTree .fancytree-folder').each((i, item: any) => {
        const vl = $(item).find('.vertical-line');
        const ftnode = item.ftnode;
        if (ftnode.children && ftnode.expanded) {
          const linkNode = ftnode.children[this.reArrangeLegforGenFieldsAtBottom(ftnode)];
          const linkRowLine = $(linkNode?.tr).find('.horizondal-line');
          if (linkRowLine && linkRowLine.offset()) {
            vl.css('display', 'block');
            const vlTop = vl.offset()?.top ?? 0;
            const hrTop = linkRowLine.offset()?.top ?? 0;
            vl.css('height', `${hrTop - vlTop - 0}px`);
          }
        } else {
          vl.css('display', 'none');
        }
      });
    }, timeout);
  }

  getParentTable(node) {
    if (node?.type === nodeType.TABLE) {
      return node;
    }
    let parentNode = node.parent;
    while (parentNode && parentNode?.type !== nodeType.TABLE) {
      parentNode = parentNode?.parent;
    }
    return parentNode;
  }

  /**
   * clear table search in datamodel
   */
  clearFilter() {
    this.searchTerm = '';
    const tree = $.ui.fancytree.getTree('#schemaTree');
    tree.clearFilter();
  }

  /**
   * clear field type search in datamodel
   */
  clearFilterData() {
    this.filter = '';
  }

  debounceFilter = debounce(this.filterTree.bind(this), this.debounceTime / 3);

  filterTreeContent(e) {
    const tree = $.ui.fancytree.getTree('#schemaTree'),
      match = e.target.value;
    console.log(`filterTreeContent match value: ${match}`);
    if ((e && e.which === $.ui.keyCode.ESCAPE) || $.trim(match as string) === '') {
      tree.clearFilter();
      this.rearrageTreeLegIndicator();
      return;
    }
    this.debounceFilter(e);
  }

  /**
   * Filters the tree based on the input value.
   *
   * @param e - The event object containing the input value to filter the tree.
   */
  filterTree(e) {
    const tree = $.ui.fancytree.getTree('#schemaTree'),
      args = 'autoApply autoExpand fuzzy hideExpanders highlight leavesOnly nodata'.split(' '),
      opts: any = {},
      filterFunc = $('#branchMode').is(':checked') ? tree.filterBranches : tree.filterNodes,
      match = e.target.value;
    if ((e && e.which === $.ui.keyCode.ESCAPE) || $.trim(match as string) === '') {
      tree.clearFilter();
      return;
    }
    console.log(`filterTree match value: ${match}`);
    $.each(args, function (i, o) {
      opts[o] = $(`#${o}`).is(':checked');
    });
    opts.mode = $('#hideMode').is(':checked') ? 'hide' : 'hide';
    const n = tree.filterNodes(match);
    this.rearrageTreeLegIndicator();
  }

  /**
   * Initializes the schema tree with the provided data.
   *
   * @param data - The data to initialize the tree with.
   *
   * @remarks
   * This method sets up a fancytree with various extensions and configurations.
   * It handles tree destruction, context menus, editing, drag-and-drop, filtering, and more.
   */
  initTree(data) {
    try {
      const treeData = cloneDeep(data);
      let parentNode;
      const $$: any = $;
      const _self = this;
      if (!this.intialSchemaLoad) {
        $('#schemaTree').fancytree('destroy');
      }
      $('#schemaTree').fancytree({
        treeId: '1',
        source: treeData,
        autoScroll: true,
        extensions: ['edit', 'dnd5', 'table', 'gridnav', 'contextMenu', 'filter'],
        quicksearch: true,
        tooltip: true,
        filter: {
          autoApply: true, // Re-apply last filter if lazy data is loaded
          autoExpand: true, // Expand all branches that contain matches while filtered
          counter: true, // Show a badge with number of matching child nodes near parent icons
          fuzzy: false, // Match single characters in order, e.g. 'fb' will match 'FooBar'
          hideExpandedCounter: true, // Hide counter badge if parent is expanded
          hideExpanders: false, // Hide expanders if all child nodes are hidden by filter
          highlight: true, // Highlight matches by wrapping inside <mark> tags
          leavesOnly: false, // Match end nodes only
          nodata: true // Display a 'no data' status node if result is empty
        },
        activate: function (e, dt) {
          if (dt?.node?.title === 'No data.') {
            dt?.node?.setActive(false);
            return;
          }
          if (dt.node && !dt.node.data.isNewRec) {
            _self.zone.run(() => {
              _self.selectedNodeTitle =
                dt.node.title && dt.node?.data?.type
                  ? `${dt.node?.data?.type === 'TABLE' ? 'Table' : 'Field'}  Properties :  ${dt.node.title}`
                  : '';
              _self.selectedNodeType = dt.node?.data?.type;
              _self.onActivateNode(dt.node);
              this.selectedNode = dt;
              _self.rowid = dt.node?.data?.sid;
            });
          }
        },
        deactivate: function (e, dt) {
          _self.prevActiveNode = dt.node;
        },
        expand: function (event, dt) {
          /* empty */
        },
        contextMenu: {
          menu: function (node) {
            const menu: any = {};
            if (!_self.disallowEdit) {
              if (_self.renderInsideModernizeMenu && _self.isStepReadOnly) {
                return;
              }
              switch (node.type) {
                case nodeType.TABLE: {
                  menu.delete = { name: 'Delete Table', icon: 'delete', disabled: false };
                  break;
                }
                case nodeType.FIELD: {
                  const isSysGenField = node.data?.sysGen || node.data?.f_sysF;
                  if (!isSysGenField) {
                    menu.delete = { name: 'Delete Field', icon: 'delete', disabled: false };
                  }
                  break;
                }
                default:
              }
            }
            return menu;
          },
          actions: function (node, action, options) {
            if (action === 'delete') {
              if (_self.isLoading) {
                _self.util.showMessage('info', _self.translate.instant('CONCURRENCY_ERROR1'));
              } else {
                _self.messageService.clear();
                if (_self.curNodeData) {
                  const key = _self.curNodeData.node.key;
                  _self.curNodeData.input.val('');
                  $(_self.curNodeData.input).blur();
                  const tree = $.ui.fancytree.getTree('#schemaTree');
                  node = tree.getNodeByKey(key);
                  if (node) {
                    _self.confirmDeletion(node);
                  }
                } else {
                  _self.confirmDeletion(node);
                }
              }
            }
          }
        },
        edit: {
          triggerStart: ['f2', 'dblclick', 'mac+enter'],
          beforeEdit: function (event: any, dt: any) {
            if (_self.renderInsideModernizeMenu && _self.isStepReadOnly) {
              return false;
            }
            if (_self.disallowEdit) {
              return false;
            }
            // Prevent editing of system generated fields (like Pid)
            if (dt.node?.data?.sysGen || dt.node?.data?.f_sysF) {
              return false;
            }
            return true;
          },
          edit: function (event: any, dt: any) {
            _self.curNodeData = dt;
            $(dt.input)
              .off('keydown')
              .on('keydown', function (evt) {
                if (evt.which !== $.ui.keyCode.ESCAPE && evt.which !== $.ui.keyCode.ENTER) {
                  evt.stopPropagation();
                  const title: any = $(dt.input).val();
                  if (title.length > _self.util.titleMaxLength) {
                    _self.zone.run(() => {
                      _self.util.showMessage(
                        'error',
                        _self.translate.instant('NAME_MAX_LENGTH_ERROR', { maxNo: _self.util.titleMaxLength })
                      );
                    });
                  }
                } else {
                  const node = dt.node;
                  switch (evt.which) {
                    case $.ui.keyCode.ESCAPE:
                      node.editEnd(false, evt);
                      break;
                    case $.ui.keyCode.ENTER:
                      node.editEnd(true, evt);
                      break;
                    default:
                      break;
                  }
                }
              });
          },
          click: function (event: any, dt: any) {
            console.log(event, dt);
          },
          beforeClose: function (event: any, dt: any) {
            if ($('#schemaTree').length === 0) {
              return true;
            }
            if (!dt.isNew && !dt.save && !dt.dirty) {
              return true;
            }
            const nodeTitle = $(dt.input).val();
            if (!nodeTitle) {
              return true;
            }
            if (!dt.originalEvent) {
              return false;
            }
            if (dt.originalEvent.target.closest('.p-toast')) {
              return false;
            } // used closet to handle the clikcks anywhere on the toast, not triggering any other actions when clicked on the toast.
            const rename = !dt.isNew && dt.save;
            let oldtitleToCheck;
            if (rename) {
              oldtitleToCheck = dt.orgTitle.toLowerCase();
              oldtitleToCheck = oldtitleToCheck.replace(/\s\s+/g, ' ');
            }
            const title: any = $(dt.input).val();

            if (dt.originalEvent?.type === 'blur') {
              dt.originalEvent.preventDefault();
              return false;
            }
            if (dt.originalEvent?.type === 'keydown') {
              if (dt.originalEvent?.keyCode === '27') {
                return true;
              }
            }
            let start = performance.now();
            if (title.length > _self.util.titleMaxLength) {
              _self.zone.run(() => {
                _self.util.showMessage(
                  'error',
                  _self.translate.instant('NAME_MAX_LENGTH_ERROR', { maxNo: _self.util.titleMaxLength })
                );
              });
              return false;
            }
            if (!title) {
              return true;
            }
            start = performance.now();
            const myRe = /^[a-zA-Z][a-zA-Z0-9 _]*$/;

            const array = myRe.exec(title);
            if (!array) {
              _self.zone.run(() => {
                _self.util.showMessage('error', _self.translate.instant('ALPHANUMEREIC_CHARACTERS_ALLOWED'));
              });
              dt.originalEvent.preventDefault();
              return false;
            }
            const node = dt.node;
            start = performance.now();
            let titleToCheck = title.toLowerCase();
            titleToCheck = titleToCheck.replace(/\s\s+/g, ' ');
            const nType = {
              TABLE: 'Table name',
              FIELD: 'Field name'
            };
            if (
              _self.util.getRestrictedKeywords().some((keyword) => keyword.toLowerCase() === titleToCheck.toLowerCase())
            ) {
              _self.zone.run(() => {
                const translatedMessage = _self.util.showKeywordWarning('Reserved Keyword', nType[node.type]);
                _self.messages.name = translatedMessage;
                _self.util.showMessage('error', translatedMessage);
                dt.input.val('');
              });
              dt.originalEvent.preventDefault();
              return false;
            }
            if (titleToCheck?.toLowerCase() === GlobalConstants.isActiveField.toLowerCase()) {
              _self.zone.run(() => {
                _self.util.showMessage('error', _self.translate.instant('RES_FLD_NAME'));
                dt.input.val('');
              });
              dt.originalEvent.preventDefault();
              return false;
            }
            if (_self.util.getRestrictedSQLKeywords().includes(titleToCheck)) {
              _self.zone.run(() => {
                const translatedMessage = _self.util.showKeywordWarning('Sql Keyword', nType[node.type]);
                _self.messages.name = translatedMessage;
                _self.util.showMessage('error', translatedMessage);
                dt.input.val('');
              });
              dt.originalEvent.preventDefault();
              return false;
            }
            start = performance.now();
            if (rename && oldtitleToCheck === titleToCheck) {
              $(dt.input).off('keydown'); //To avoid memory leak
              return true;
            }
            if (_self.isLoading && !rename) {
              _self.zone.run(() => {
                _self.util.showMessage('info', this.translate.instant('CONCURRENCY_ERROR1'));
              });
              _self.waitingNode = node;
              dt.originalEvent.preventDefault();
              return false;
            }

            _self.messageService.clear();

            switch (node.type) {
              case nodeType.TABLE:
                if (!_self.tableTitles) {
                  _self.tableTitles = [titleToCheck];
                }
                if (
                  _self.util.getRestrictedTableKeywords().includes(titleToCheck?.toLowerCase()?.replace(/\s+/g, ''))
                ) {
                  _self.zone.run(() => {
                    const translatedMessage = _self.util.showKeywordWarning('Reserved Keyword', titleToCheck);
                    _self.util.showMessage('error', translatedMessage);
                  });
                  dt.originalEvent.preventDefault();
                  return false;
                } else if (_self.tableTitles.includes(titleToCheck)) {
                  _self.zone.run(() => {
                    _self.util.showMessage('error', _self.translate.instant('DUPLICATE_TABLENAME'));
                  });
                  dt.originalEvent.preventDefault();
                  return false;
                }
                if (rename && _self.tableTitles.includes(oldtitleToCheck)) {
                  const i = _self.tableTitles.indexOf(oldtitleToCheck);
                  _self.tableTitles[i] = titleToCheck;
                } else {
                  _self.tableTitles.push(titleToCheck);
                }

                break;
              case nodeType.FIELD: {
                const parentKey = _self.getParentTable(node)?.key;
                const tableFields = _self.fieldTitles[parentKey];
                const namesToValidate = tableFields?.map((f: string) => f.toLowerCase().replace(/ /g, ''));
                if (_self.sysGenFields.includes(titleToCheck)) {
                  _self.zone.run(() => {
                    _self.util.showMessage(
                      'error',
                      `${_self.translate.instant('SYS_FLD_WARN')} : ${_self.sysGenFields.join(', ')}`
                    );
                  });
                  dt.originalEvent.preventDefault();
                  return false;
                }
                if (namesToValidate && namesToValidate.includes(titleToCheck.replace(/ /g, ''))) {
                  _self.zone.run(() => {
                    _self.util.showMessage('error', _self.translate.instant('DUPLICATE_FIELDNAME'));
                  });
                  dt.originalEvent.preventDefault();
                  return false;
                }
                if (tableFields) {
                  if (rename && tableFields.includes(oldtitleToCheck)) {
                    const i = _self.fieldTitles[parentKey].indexOf(oldtitleToCheck);
                    _self.fieldTitles[parentKey][i] = titleToCheck;
                  } else {
                    _self.fieldTitles[parentKey].push(titleToCheck);
                  }
                } else {
                  _self.fieldTitles[parentKey] = [titleToCheck];
                }

                break;
              }
              default:
                break;
            }
            $(dt.input).off('keydown'); //To avoid memory leak
            return true;
          },
          save: function (event: any, dt: any) {
            setTimeout(function () {
              // To check whether the node is available in tree because concurrent user might have delete
              const tree = $.ui.fancytree.getTree('#schemaTree');
              const treNode = tree.getNodeByKey(dt.node.key);
              if (treNode) {
                let title = dt.node.title;
                title = title.replace(/\s\s+/g, ' '); //Remove multiple spaces inside the name
                dt.node.setTitle(title);
                _self.updatePropertiesTask(dt.node);
              }
            });
            return true;
          },
          close: function (event: any, dt: any) {
            // Editor was removed
            _self.curNodeData = null;
          }
        },
        dnd5: {
          preventRecursion: true, // Prevent dropping nodes on own descendants
          preventVoidMoves: true, // Prevent moving nodes 'before self', etc.
          preventForeignNodes: true,
          dragStart: function (node, dt: any) {
            dt.effectAllowed = 'all';
            dt.dropEffect = 'move';
            // Return true to allow the drag operation
            if (dt.node.data.sysGen) {
              return false;
            }
            if (dt.node.type === nodeType.FIELD) {
              parentNode = _self.getParentTable(dt.node);
            }
            return true;
          },
          dragEnter: function (node, dt) {
            return true;
          },
          dragDrop: function (node: any, dt) {
            const transfer = dt.dataTransfer,
              sourceNodes = dt.otherNodeList,
              mode = dt.dropEffect;
            if (dt.hitMode === 'after') {
              // If node are inserted directly after tagrget node one-by-one,
              // this would reverse them. So we compensate:
              sourceNodes.reverse();
            }
            if (dt.otherNode) {
              if (_self.isLoading) {
                _self.util.showMessage('info', this.translate.instant('CONCURRENCY_ERROR1'));
              } else {
                _self.messageService.clear();
                // Drop another Fancytree node from same frame (maybe a different tree however)
                if (mode === 'move') {
                  if (dt.otherNode.type === nodeType.FIELD) {
                    if (
                      ((dt.hitMode === 'after' || dt.hitMode === 'before') && node.type === nodeType.FIELD) ||
                      (dt.hitMode === 'over' && node.type === nodeType.TABLE)
                    ) {
                      const curParent = _self.getParentTable(dt.node);
                      if (
                        parentNode.data?.sid === curParent.data?.sid &&
                        _self.checkForDuplicates(node, dt.otherNode)
                      ) {
                        _self.updateonDragEnd(node, dt);
                      }
                    }
                  } else if (dt.otherNode.type === nodeType.TABLE) {
                    if ((dt.hitMode === 'after' || dt.hitMode === 'before') && node.type === nodeType.TABLE) {
                      _self.updateonDragEnd(node, dt);
                    }
                  }
                }
              }
            } else {
              // Drop a non-node
              node.addNode({ title: transfer.getData('text') }, dt.hitMode);
            }
          }
        },
        table: {
          indentation: 40,
          nodeColumnIdx: 1,
          checkboxColumnIdx: 0
        },
        gridnav: {
          autofocusInput: false,
          handleCursorKeys: true
        },
        createNode: function (event, dt) {
          const node: any = dt.node,
            $tdList = $(node.tr).find('>td');
          if (node.type === nodeType.TABLE) {
            if (!node.isFolder()) {
              dt.node.folder = true;
            }
          }
          const childs = node.children || [];
          const levelClassc = `level${node.getLevel()}`;
          let nodeVerticalBarHeight = 36 * (childs.length - 1) - 10; //+ 13 + 20;
          // Span the remaining columns if it's a folder.
          // We can do this in createNode instead of renderColumns, because
          // the `isFolder` status is unlikely to change later
          if (node.isFolder()) {
            const verticalLine = $('<div>')
              .addClass(`vertical-line ${levelClassc}`)
              .css({
                height: `${nodeVerticalBarHeight}px`
              });
            if (!node.isExpanded()) {
              verticalLine.hide();
            }
            $($tdList[1]).append(verticalLine);
            if (levelClassc !== 'level1') {
              const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
              $($tdList[1]).append(horizondalLine);
            }
            $tdList.eq(1).prop('colspan', 2);
            $tdList.eq(1).next().remove();
            $tdList.eq(2).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
          } else {
            if (node.children) {
              console.log('node.children');
              console.log(node.children);
              nodeVerticalBarHeight = node.children.length * 36 - 10;
              const verticalLine = $('<div>')
                .addClass(`vertical-line ${levelClassc}`)
                .css({
                  height: `${nodeVerticalBarHeight}px`
                });
              if (!node.isExpanded()) {
                verticalLine.hide();
              }
              $($tdList[1]).append(verticalLine);
            }
            const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
            $($tdList[1]).append(horizondalLine);
            const parentNde: any = _self.getParentTable(node);
            $(node.tr).attr('pid', parentNde?.data?.sid);
          }
          if (!node.icon) {
            switch (node.type) {
              case nodeType.FIELD:
                node.icon = 'fa pen-field field-icon';
                break;
              case nodeType.TABLE:
                node.icon = 'fa table table-icon';
                break;
              default:
                break;
            }
            node.renderTitle();
          }
        },
        renderColumns: function (event, dt) {
          if (dt.tree.count() > 1) {
            $('.btn-wrapper').addClass('d-none');
          }
          const node: any = dt.node;
          const $tdList = $(node.tr).find('>td');
          if (node.type === nodeType.TABLE) {
            processTableNode();
          } else if (node.type === nodeType.FIELD) {
            processFieldNode();
          }

          function processFieldNode() {
            const isSysGenField = node.data?.sysGen || node.data?.f_sysF;
            // if(!isSysGenField){
            //   $tdList.eq(1).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
            // } else{
            //   $tdList.eq(1).off('click');
            // }
            if (!$tdList.eq(2).find('.dropdown-toggle').length) {
              $tdList.eq(2).append(`<div class="dropdown dataTypes">
                <button class="btn dropdown-toggle toggle-button hidden"
                    type="button" [disabled]="disallowEdit"
                    id="data-field-type">
                    {{ 'STRING' | translate }}
                </button>
            </div>`);
              $tdList.eq(2)[0].classList.add('field-type');
            }
            $tdList.eq(2).find('.dropdown-toggle')[0]?.classList.remove('hidden');
            if (_self.disallowEdit || isSysGenField) {
              $tdList.eq(2).find('.dropdown-toggle').attr('disabled', 'true');
            }
            const fieldType = node.data.f_type || 'String';
            const fieldVal = filter(_self.dataTypes, (e: any) => e.value === fieldType);
            let fieldName = '';
            if (fieldVal[0]) {
              fieldName = fieldVal[0].name;
            }
            $tdList.eq(2).find('#data-field-type').text(fieldName);
            if (!isSysGenField) {
              $tdList.eq(2).off('click').on('click', '#data-field-type', _self.selectType.bind(_self));
            }
            if (!$tdList.eq(3).find('.contextMenu').length) {
              $tdList.eq(3).append(`<div class="dropdown contextMenu">
                <button class="btn toggle-button p-button-icon-only"
                    id="context-menu-trigger"${isSysGenField ? ' disabled' : ''}>
                   <span class="pi pi-ellipsis-v p-button-icon"></span>
                </button>
            </div>`);
              $tdList.eq(3)[0].classList.add('context-menu-td');
            }
            if (!isSysGenField) {
              $tdList.eq(3).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
            } else {
              $tdList.eq(3).find('#context-menu-trigger').attr('disabled', 'true');
            }
          }

          function processTableNode() {
            if (!$tdList.eq(2).find('.contextMenu').length) {
              $tdList.eq(2).append(`<div class="dropdown contextMenu">
                <button class="btn toggle-button p-button-icon-only"
                    id="context-menu-trigger">
                   <span class="pi pi-ellipsis-v"></span>
                </button>
            </div>`);
              $tdList.eq(2)[0].classList.add('context-menu-td');
            }
            $tdList.eq(2).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
          }
        },
        modifyChild: function (event: any, dt: any) {
          dt.tree.info(event.type, dt);
          _self.rearrageTreeLegIndicator(50);
        },
        click: (event: any, dt: any) => {
          if (dt?.node?.title === 'No data.') {
            return false;
          }
          _self.selectedNodeTitle =
            dt && dt.node && dt.node.title && dt.node.type
              ? `${dt.node.type === 'TABLE' ? 'Table' : 'Field'}  Properties :  ${dt.node.title}`
              : '';
          _self.selectedNodeType = dt?.node?.type;
          if (_self.rowid !== dt.node.data.sid && _self.rowid !== '' && !dt.node.data.isNewRec) {
            this.zone.run(() => {
              _self.onActivateNode(dt.node);
              this.selectedNode = dt;
            });
          }
          _self.rowid = dt.node.data.sid;
          const target = event.originalEvent?.target;
          const row$ = $(dt.node.tr);
          if ($(target).hasClass('fancytree-expander')) {
            if (dt.node.isExpanded()) {
              row$.find('.vertical-line').hide();
            } else {
              row$.find('.vertical-line').show();
            }
            _self.rearrageTreeLegIndicator(50);
          } else {
            _self.rearrageTreeLegIndicator();
          }
          return true;
        },
        init: function (event, dt) {
          _self.isLoading = false;
          _self.propertyLoading = false;
        }
      });
      _self.rearrageTreeLegIndicator(50);
    } catch (err) {
      console.error(err);
    }
  }

  onActivateNode(node) {
    if (node.type === nodeType.TABLE || node.type === nodeType.FIELD) {
      this.propertyPaneData = node.data;
      this.showPropPane = true;
    } else {
      this.propertyPaneData = null;
      this.showPropPane = false;
    }
  }

  selectType(event) {
    if (this.renderInsideModernizeMenu && this.isStepReadOnly) {
      return;
    }
    try {
      this.selectedRow = event.currentTarget.closest('tr');
      this.dataTypeOp.toggle(event);
      setTimeout(() => {
        $('#filter').focus();
      }, 100);
    } catch (e) {
      console.error(e);
    }
  }

  openContextMenu(event) {
    if (this.renderInsideModernizeMenu && this.isStepReadOnly) {
      return;
    }
    try {
      if (event.originalEvent.pointerId < 0) {
        return;
      }
      $(event.currentTarget).parent().parent().parent().find('.fancytree-title').contextMenu();
      $('.context-menu-list').css('visibility', 'hidden');
      setTimeout(() => {
        $(event.currentTarget);
        $('.context-menu-list').css('left', event.clientX);
        $('.context-menu-list').css('visibility', 'visible');
      }, 0);
    } catch (e) {
      console.error(e);
    }
  }

  formTreelinesOnDrop(node) {
    const childs = node.children || [];
    const levelClassc = `level${node.getLevel()}`;
    const nodeVerticalBarHeight = 36 * (childs.length - 1) - 10; //+ 13 + 20;
    const $tdList = $(node.tr).find('>td');
    if (node.isFolder()) {
      const verticalLine = $('<div>')
        .addClass(`vertical-line ${levelClassc}`)
        .css({
          height: `${nodeVerticalBarHeight}px`
        });
      if (!node.isExpanded()) {
        verticalLine.hide();
      }
      // remove already existing lines and then append
      $($tdList[1]).find('>.vertical-line')?.remove();
      $($tdList[1]).find('>.horizondal-line')?.remove();
      $($tdList[1]).append(verticalLine);
      if (levelClassc !== 'level1') {
        const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
        $($tdList[1]).append(horizondalLine);
      }
      if (node.children) {
        node.children.forEach((nd) => {
          this.formTreelinesOnDrop(nd);
        });
      }
    } else {
      const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
      // remove already existing lines and then append
      $($tdList[1]).find('>.vertical-line')?.remove();
      $($tdList[1]).find('>.horizondal-line')?.remove();
      $($tdList[1]).append(horizondalLine);
    }
  }

  updateonDragEnd(node, dt) {
    const otherNode = dt.otherNode;
    const prevSib = otherNode.getPrevSibling();
    dt.otherNode.moveTo(node, dt.hitMode);
    const newPrevSib = otherNode.getPrevSibling();
    const parNode = otherNode.getParent();
    const apidata = {
      draggedNode: otherNode.data.sid,
      type: otherNode.data.type,
      dragFrom: prevSib?.data.sid,
      dragTo: newPrevSib?.data.sid,
      dragFromPNode: prevSib?.data.pNode,
      dragToPNode: newPrevSib?.data.pNode,
      pNode: parNode.title === 'root' ? null : parNode.data.sid,
      appId: this.appId,
      orgId: this.orgId,
      tabId: this.tabId
    };
    this.isLoading = true;
    this.triggerApi(ApiConstants.dragDropAiDM, apidata);

    const failSub = this.store.select(aiDMFailData).subscribe((d) => {
      if (d) {
        this.isLoading = false;
        if (d.err) {
          this.showErrMsg(dt);
          if (failSub) {
            failSub.unsubscribe();
          }
          this.initialCall = true;
          this.getDataFromFS();
        }
      }
    });
    const succSub = this.store.select(aiDMSuccData).subscribe((d) => {
      console.log(d);
      if (d) {
        this.isLoading = false;
        this.messageService.clear();
        if (succSub) {
          succSub.unsubscribe();
        }
      }
    });
    this.formTreelinesOnDrop(node);
    if (dt?.node?.title !== 'root') {
      this.formTreelinesOnDrop(this.activeNode);
    }
  }

  checkForDuplicates(copyToNode, currNode) {
    if (currNode.type === nodeType.FIELD) {
      const otherNodeParent = this.getParentTable(copyToNode);
      const nodeParent = this.getParentTable(currNode);
      if (otherNodeParent === nodeParent) {
        return true;
      }
      const coptToparentTable = copyToNode.type === nodeType.TABLE ? copyToNode : this.getParentTable(copyToNode);
      const parentKey = coptToparentTable.key;
      const tableFields = this.fieldTitles[parentKey];
      const title = currNode.title.toLowerCase();
      if (tableFields && tableFields.includes(title)) {
        this.util.showMessage('error', 'Duplicate Field names not allowed');
        return false;
      }
      if (tableFields) {
        this.fieldTitles[parentKey].push(title);
      } else {
        this.fieldTitles[parentKey] = [title];
      }
      const oldParentKey = this.getParentTable(currNode)?.key;
      const index = this.fieldTitles[oldParentKey].indexOf(title);
      if (index > -1) {
        this.fieldTitles[oldParentKey].splice(index, 1);
      }
    }
    return true;
  }

  processTreeData(d) {
    let data: any = [];
    if (d.title === 'root' && d.children) {
      data = [...d.children];
    }
    return data;
  }

  formConfirmationMessage(node) {
    const name = node.title;
    const messageObj = {
      [nodeType.FIELD]: `${this.translate.instant('FLD_DEL_CONF')} "${name}" ? `,
      [nodeType.TABLE]: `${this.translate.instant('TBL_DEL_CONF')} "${name}" ? `
    };
    let confirmationMessage = messageObj[node.type];
    if (this.renderInsideModernizeMenu && node.type == nodeType.TABLE) {
      const hasWorkflow = this.workflowAssociated;
      const hasAssociatedPage = this.interimScreens.some(
        (screen: any) => screen.tableName?.toLowerCase() === name?.toLowerCase()
      );
      if (hasWorkflow && hasAssociatedPage) {
        confirmationMessage = this.translate.instant('WORKFLOW_AND_PAGE_ASSOCIATED_DELETE_CONFIRMATION', { component: name }) + messageObj[node.type];
      } else if (hasWorkflow) {
        confirmationMessage = this.translate.instant('WORKFLOW_ASSOCIATED_COMPONENTS_DELETE_CONFIRMATION', { component: name }) + messageObj[node.type];
      } else if (hasAssociatedPage) {
        confirmationMessage = this.translate.instant('PAGE_ASSOCIATED_DELETE_CONFIRMATION', { component: name }) + messageObj[node.type];
      }
    } else if (this.renderInsideModernizeMenu && this.workflowAssociated) {
      if (node.type == nodeType.FIELD && node.data.f_type == 'Dropdown') {
        const workflowDeletionWarning = this.translate.instant('WORKFLOW_ASSOCIATED_COMPONENTS_DELETE_CONFIRMATION', { component: name });
        confirmationMessage = workflowDeletionWarning + messageObj[node.type];
      }
    }
    return confirmationMessage;
  }

  /**
   * Calls the API based on the specified action and node data.
   *
   * @param node - The node object containing data for the API call.
   * @param action - The action to be performed ('delete' or 'fieldTypeChange').
   * @param value - Optional parameter for the new field type when action is 'fieldTypeChange'.
   *
   * It handles the response by updating the UI accordingly or displaying errors and warnings if present.
   */
  callApi(node, action, value?) {
    this.isLoading = true;
    let payload;
    let apiConstants;
    if (action === 'delete') {
      apiConstants = ApiConstants.deleteAiDM;
      payload = { deleted: [node.data.sid], tabId: this.tabId };
    } else if (action === 'fieldTypeChange') {
      apiConstants = ApiConstants.dataTypAiDM;
      payload = {
        aid: this.appId,
        orgId: this.orgId,
        f_type: value,
        old_f_type: node?.data?.f_type,
        f_tableId: node?.data?.f_tableId,
        sid: node?.data?.sid,
        tabId: this.tabId,
        type: nodeType.FIELD
      };
    }
    const delSub = this.baseService[apiConstants.method](apiConstants, payload).subscribe(
      (response) => {
        this.isLoading = false;
        if (response?.body) {
          this.handleApiResponse(response.body, node, action, value);
        }
      },
      (e) => {
        console.error(e);
        this.isLoading = false;
      }
    );
    this.addToSubscriptionsList(delSub);
  }

  private handleApiResponse(body: any, node: any, action: string, value?: string): void {
    if (
      'errorsAndWarnings' in body &&
      body.errorsAndWarnings?.length > 0
    ) {
      this.showPreValidationModal(body);
    } else if (action === 'delete') {
      this.handleDeleteResponse(node);
    } else if (action === 'fieldTypeChange') {
      this.handleFieldTypeChangeResponse(node, value!);
    }
  }

  private showPreValidationModal(err: any): void {
    const preValmodal = this.dialogService!.open(PreValidationTblViewComponent, {
      showHeader: false,
      styleClass: 'reference-tree',
      modal: true,
      data: {
        prevalidationList: {
          preValicationList: err.errorsAndWarnings,
          type: 'cudConfig',
          aiMetaData: { ...this.tableMap, ...this.tableFieldMap }
        }
      }
    });
    const sub = preValmodal.onClose.subscribe(() => {
      /* empty */
    });
    this.subscriptions.push(sub);
  }

  private handleDeleteResponse(node: any): void {
    const isTableDelete = node.type === nodeType.TABLE;
    try {
      node.remove();
    } catch (e) {
      // Node may have already been removed by the Firestore real-time listener
    }
    this.showPropPane = false;
    this.selectedNodeTitle = null;
    setTimeout(() => {
      this.processTree();
      if (this.dataModelDataOrder.length === 0) {
        this.initTree(this.dataModelDataOrder);
      }
      // Delay screen refresh to allow backend cascade-delete to complete
      if (isTableDelete && this.renderInsideModernizeMenu) {
        setTimeout(() => {
          this.refreshScreenInterimsAfterTableDelete();
        }, 500);
      }
    }, 100);
  }

  private handleFieldTypeChangeResponse(node: any, value: string): void {
    node.data = { ...node.data, ...{ f_type: value, tabId: this.tabId } };
    if (this.selectedRow) {
      const fieldVal = this.dataTypes.find((e) => e.value === value);
      $(this.selectedRow)
        .find('>td')
        .eq(2)
        .find('#data-field-type')
        .text(fieldVal ? fieldVal.name : value);
    }
  }

  confirmDeletion(node) {
    const message = this.formConfirmationMessage(node);
    const _self = this;
    const confirmationObj = {
      header: this.translate.instant('CONFIRMATION'),
      message,
      accept: () => {
        _self.callApi(node, 'delete');
      },
      reject: () => {
        return;
      }
    };
    this.zone.run(() => {
      _self.confirmationDialogService.confirm(confirmationObj);
    });
  }

  private refreshScreenInterimsAfterTableDelete() {
    this.store.select(GenerationSelectors.selectGeneration).pipe(take(1)).subscribe((generation) => {
      const generationId = generation?.sid;
      if (generationId) {
        this.store.dispatch(ScreenInterimActions.getScreensInterim({
          getScreensInterimApiConstants: ApiConstants.getAllScreensInterim,
          payloadWithPathVariables: {
            generationId,
            start: 0,
            length: 10000,
            order: [],
            removeUrlVariables: ['generationId']
          }
        }));
      }
    });
  }

  updateTitle(node) {
    if (node.type === nodeType.FIELD) {
      this.tableFieldMap = { ...this.tableFieldMap, ...{ [node.data.sid]: node.title } };
    } else {
      this.tableMap = { ...this.tableMap, ...{ [node.data.sid]: node.title } };
    }
  }

  // Renaming fancytreenode
  updatePropertiesTask(node) {
    const data = cloneDeep(node.data);
    if (!data) {
      return;
    }
    const properties = { ...data, name: node.title, tabId: this.tabId };
    this.updateTitle(node);
    node.data.name = node.title;
    const dataToSend = {
      aid: this.appId,
      orgId: this.orgId,
      name: properties.name,
      sid: properties?.sid,
      tabId: this.tabId
    };
    this.triggerApi(ApiConstants.renameAiDM, dataToSend);
    // Refresh screen interims after table rename so page names stay in sync
    if (node.type === nodeType.TABLE && this.renderInsideModernizeMenu) {
      this.refreshScreenInterimsAfterTableDelete();
    }
  }

  setDataType(value) {
    const tree = $.ui.fancytree.getTree('#schemaTree');
    const node = tree.getActiveNode();
    this.dataTypeOp.hide();
    if (node.data.f_type !== value) {
      this.callApi(node, 'fieldTypeChange', value);
    }
  }

  eventTracker: any = {
    trackedEvents: {},

    start: function (key) {
      const startTime = new Date();
      this.trackedEvents[key] = {
        start: startTime
      };
    },

    stop: function (key) {
      const endTime: any = new Date();
      this.trackedEvents[key].duration = `${this.trackedEvents[key].start} ${endTime}  ========> ${
        (endTime - this.trackedEvents[key].start) / 1000
      }s`;
      this.trackedEvents[key].end = endTime;
    }
  };

  formChildren(dataMap, nxtNodeMap, firstChildMap, node) {
    const output: any = [];
    while (node) {
      if (firstChildMap.get(node.data.sid)) {
        let child = [];
        const childNode = dataMap.get(firstChildMap.get(node.data.sid));
        child = this.formChildren(dataMap, nxtNodeMap, firstChildMap, childNode);
        node = { ...node, ...{ children: child } };
      }
      output.push(node);
      const nsid = nxtNodeMap.get(node.data.sid);
      node = nsid ? dataMap.get(nsid) : null;
    }
    return output;
  }

  formNode(obj) {
    if (obj.modifiedDate && obj.modifiedDate.seconds) {
      obj.modifiedDate = new Date(obj.modifiedDate.seconds * 1000);
    }
    if (obj.createdDate && obj.createdDate.seconds) {
      obj.createdDate = new Date(obj.createdDate.seconds * 1000);
    }
    return {
      key: obj.sid,
      title: obj.name,
      type: obj.type,
      folder: obj.type !== nodeType.FIELD,
      data: { ...obj }
    };
  }

  /**
   * Constructs a tree structure from the given data structure.
   *
   * @param {Array} structure - The array of objects representing the structure to be converted into a tree.
   *
   * @remarks
   * This method initializes several maps to keep track of nodes, their children, and their order.
   * It iterates through the structure array, forms nodes, and populates the maps accordingly.
   * It also sets titles for tables and fields, and handles index and foreign key names.
   * Finally, it forms the children of the data model and logs the duration of the operation.
   */
  constructTree(structure) {
    this.eventTracker.start('constructTree');
    const dataMap = new Map();
    const firstChildMap = new Map();
    const nxtNodeMap = new Map();
    let curNode;
    structure.forEach((obj) => {
      const node = this.formNode(obj);
      dataMap.set(obj.sid, node);
      if (!obj.preNode) {
        if (!obj.pNode) {
          curNode = { ...node, ...{ expanded: true } };
        }
        firstChildMap.set(obj.pNode, obj.sid);
      }
      if (obj.preNode) {
        nxtNodeMap.set(obj.preNode, node.data.sid);
      }
      // set title map for table and field
      const title = obj?.name?.trim()?.replace(/\s\s+/g, ' ')?.toLowerCase();
      if (obj.type === nodeType.TABLE) {
        this.tableTitles.push(title);
        this.tableMap = { ...this.tableMap, ...{ [obj?.sid]: obj.name } };
        // Include index and foreignkey name also in the map
        try {
          if (obj.t_index) {
            JSON.parse(obj.t_index).forEach((e) => {
              this.tableMap = { ...this.tableMap, ...{ [e.sid]: e.indexName } };
            });
          }
          if (obj.t_fKey) {
            JSON.parse(obj.t_fKey).forEach((e) => {
              this.tableMap = { ...this.tableMap, ...{ [e.sid]: e.fkName } };
            });
          }
        } catch (e) {
          console.error(e);
        }
      } else if (obj.type === nodeType.FIELD) {
        if (obj?.f_tableId in this.fieldTitles) {
          this.fieldTitles[obj.f_tableId].push(title);
        } else {
          this.fieldTitles = { ...this.fieldTitles, ...{ [obj.f_tableId]: [title] } };
        }
        this.tableFieldMap = { ...this.tableFieldMap, ...{ [obj?.sid]: obj.name } };
      }
    });
    this.dataModelDataOrder = this.formChildren(dataMap, nxtNodeMap, firstChildMap, curNode);
    this.dataModelCountChange.emit(this.dataModelDataOrder.length);

    // Build availableTables for properties pane
    this.availableTables = structure
      .filter((obj) => obj.type === nodeType.TABLE)
      .map((obj) => ({ sid: obj.sid, name: obj.name }));

    this.constructTableFieldMap(structure);
    this.eventTracker.stop('constructTree');
    console.log(`constructTree : ${this.eventTracker.trackedEvents.constructTree.duration}`);
  }

  constructTableFieldMap(structure) {
    structure.forEach((obj) => {
      if (obj.type === nodeType.TABLE) {
        this.tableAndFieldDataMap[obj.sid] = {
          name: obj.name,
          fields: [...(this.tableAndFieldDataMap[obj.sid]?.fields || [])]
        };
      } else {
        if (obj.type === nodeType.FIELD && obj.f_tableId) {
          if (this.tableAndFieldDataMap[obj.f_tableId]) {
            this.tableAndFieldDataMap[obj.f_tableId].fields.push({
              sid: obj.sid,
              name: obj.name
            });
          } else {
            this.tableAndFieldDataMap[obj.f_tableId] = {
              name: '',
              fields: [
                {
                  sid: obj.sid,
                  name: obj.name
                }
              ]
            };
          }
        }
      }
    });
  }

  modifyNode(curnode, data) {
    if (curnode.title !== data.name && !curnode.isEditing()) {
      curnode.title = data.name;
      curnode.setTitle(data.name);
      this.updateTitle(curnode);
    }
    if (curnode.data.f_type !== data.f_type) {
      const $tdList = $(curnode.tr).find('>td');
      const fieldValue = filter(this.dataTypes, (e: any) => e.value === data.f_type);
      const fieldName = fieldValue[0] ? fieldValue[0].name : '';
      $tdList.eq(2).find('#data-field-type').text(fieldName);
    }
    // if (this.rowid === data.sid) {

    // }
    curnode.data = { ...curnode.data, ...data };
    this.propertyPaneData = data;
  }

  moveNode(node, data) {
    const tree = $.ui.fancytree.getTree('#schemaTree');
    if (data.preNode) {
      const preNode = tree.getNodeByKey(data.preNode);
      node.moveTo(preNode, 'after');
      if (node.isEditing() && node.title !== data.name) {
        this.updateTitle(node);
        node.title = data.name;
        this.curNodeData.input.val(data.name);
        $(this.curNodeData.input).blur();
        this.zone.run(() => {
          this.util.showMessage('info', `${this.curNodeData.orgTitle} is updated to ${data.name} by different user.`);
        });
      }
    } else if (data.pNode) {
      const parentNode = tree.getNodeByKey(data.pNode);
      if (parentNode && parentNode?.hasChildren()) {
        const firstChild = parentNode.children[0];
        node.moveTo(firstChild, 'before');
      } else {
        node.moveTo(parentNode, 'over');
      }
    } else {
      // if a node moved to the top
      const rootNode = tree.getRootNode();
      if (rootNode && rootNode.hasChildren()) {
        const firstChild = rootNode.children[0];
        node.moveTo(firstChild, 'before');
      }
    }
  }

  /**
   * Appends a new node to the tree from Firebase data.
   */
  appendNode(data) {
    const node = this.formNode(data);
    const tree = $.ui.fancytree.getTree('#schemaTree');
    const anchorSid = node.data.preNode || node.data.pNode;
    const anchorNode = tree.getNodeByKey(anchorSid);

    if (anchorNode) {
      const mode = node.data.preNode ? 'after' : 'over';
      anchorNode.addNode(node, mode);
    }

    // Update title maps for validation and error display
    const title = data?.name?.trim()?.replace(/\s\s+/g, ' ')?.toLowerCase();
    if (data.type === nodeType.TABLE) {
      this.tableTitles.push(title);
      this.tableMap = { ...this.tableMap, [data.sid]: data.name };
    } else if (data.type === nodeType.FIELD) {
      if (this.fieldTitles[data.f_tableId]) {
        this.fieldTitles[data.f_tableId].push(title);
      } else {
        this.fieldTitles[data.f_tableId] = [title];
      }
      this.tableFieldMap = { ...this.tableFieldMap, [data.sid]: data.name };
    }
    this.fsData.push(data);
  }

  /**
   * Updates a node in the FancyTree based on the provided action.
   *
   * @param data - The data object containing information about the node.
   * @param action - The action to be performed on the node. Can be 'modified' or 'removed'.
   *
   * The function performs the following actions based on the value of `action`:
   * - 'modified': Updates the node's data and potentially moves it within the tree.
   * - 'removed': Removes the node from the tree and updates the UI accordingly.
   *
   * The function also handles updating the properties pane if the modified or removed node is the currently selected node.
   */
  updateNodeFromFS(data, action) {
    delete data.actionType;
    const tree = $.ui.fancytree.getTree('#schemaTree');
    if (!tree) {
      return;
    }
    switch (action) {
      case 'added': {
        const existingNode = tree.getNodeByKey(data.sid);
        if (existingNode) {
          // Node already in tree - update with server data
          if (data.modifiedDate?.seconds) {
            data.modifiedDate = new Date(data.modifiedDate.seconds * 1000);
          }
          existingNode.data = { ...existingNode.data, ...data };
        } else {
          // New node - append to tree
          this.appendNode(data);
        }
        break;
      }
      case 'modified': {
        const curnode = tree.getNodeByKey(data.sid);
        if (curnode) {
          const prevNode = curnode.getPrevSibling();
          if (data.modifiedDate && data.modifiedDate.seconds) {
            data.modifiedDate = new Date(data.modifiedDate.seconds * 1000);
          }
          if (data.createdDate && data.createdDate.seconds) {
            data.createdDate = new Date(data.createdDate.seconds * 1000);
          }
          if (
            curnode.data.preNode !== data.preNode ||
            curnode.data.pNode !== data.pNode ||
            (prevNode && prevNode.data.sid !== data.preNode)
          ) {
            this.moveNode(curnode, data);
            // update the prenode/ pnode to properties pane if it is active node
            if (this.rowid === data.sid) {
              this.propertyPaneData = data;
            }
            curnode.data = data;
          } else if (data.modifiedDate && curnode.data.modifiedDate) {
            const date1 = new Date(data.modifiedDate).getTime();
            const date2 = new Date(curnode.data.modifiedDate).getTime();
            if (date1 > date2) {
              this.modifyNode(curnode, data);
            }
          } else {
            this.modifyNode(curnode, data);
          }
        }
        break;
      }
      case 'removed': {
        const curnode1 = tree.getNodeByKey(data.sid);
        if (this.rowid === data.sid) {
          this.showPropPane = false;
          this.selectedNodeTitle = null;
          this.curNodeData = null;
        }
        if (curnode1) {
          // this.removeTitles(curnode1);
          // To check whether the node is in edit mode
          if (curnode1.isEditing()) {
            this.util.showMessage(
              'info',
              `The Editing ${this.curNodeData.node.type} Node was removed by ${this.appGlobalService?.get('appmetaInfo')[data.modifiedBy]}.`
            );
            this.curNodeData.input.val('');
            $(this.curNodeData.input).blur();
          }
          curnode1.remove();

          // Clean up field maps
          if (this.tableFieldMap && this.tableFieldMap[data.sid]) {
            delete this.tableFieldMap[data.sid];
          }

          // Update dataModelDataOrder and emit count so the UI stays in sync
          this.processTree();
        }
        break;
      }
      default:
        break;
    }
    // this.saveFancyTreeOrder();
  }

  /**
   * Fetches data from Firestore based on the application version and upload ID.
   * Constructs a query object to filter data by 'aid' and 'uploadId'.
   * Starts an event tracker for 'AIImpSchApplicationDataModel' and unsubscribes any existing listeners.
   * Sets the loading state to true and subscribes to the Firestore service with the query object.
   *
   * It processes the response data, filters out cached and deleted records,
   * clones the data, constructs a tree, initializes the tree with the data model order, and handles
   * the visualizer visibility based on the data model order length.
   */
  getDataFromFS() {
    // const version = this.appGlobalService.get('appVersion');
    try {
      const queryObject = this.getAIApplicationDataModelQueryObject();
      this.eventTracker.start('AIImpSchApplicationDataModel');
      this.unsubscribeListener(this.unSubDMList);
      this.isLoading = true;
      const fsDataSub = this.fsService.fireService(queryObject).subscribe(
        (res) => {
          this.eventTracker.stop('AIImpSchApplicationDataModel');
          console.log(
            `AIImpSchApplicationDataModel : ${this.eventTracker.trackedEvents.AIImpSchApplicationDataModel.duration}`
          );
          if (this.initialCall) {
            this.isLoading = false;
            this.initialCall = false;
            const data = res
              .filter((dt) => !dt.payload.doc.metadata.fromCache && !dt.payload.doc.data().recDeleted)
              .map((obj) => {
                return obj.payload.doc.data();
              });
            this.fsData = cloneDeep(data);
            this.constructTree(data);
            this.initTree(this.dataModelDataOrder);
            this.intialSchemaLoad = false;
            if (this.triggerImport) {
              if (this.dataModelDataOrder.length) {
                setTimeout(() => {
                  this.isVisualizerVisible = true;
                }, 100);
              }
              this.triggerImport = false;
            }
          } else {
            const data = res
              .filter((obj) => !obj.payload.doc.metadata.hasPendingWrites && !obj.payload.doc.metadata.fromCache)
              .map((dt) => {
                const rec = dt.payload.doc.data();
                rec.actionType = rec.recDeleted ? 'removed' : dt.type;
                return rec;
              });
            // if (data.length > 0) {
            // this.fsData = newData.length > 0 ? [...this.fsData, ...newData] : this.mergeFsData(data, this.fsData);
            data.forEach((obj) => {
              const updData = this.fsData.map((dt) => (dt.sid === obj.sid ? dt : obj));
              this.fsData = [...updData];
              this.updateNodeFromFS(obj, obj.actionType);
            });
            // }
          }
        },
        (error) => {
          console.error(error);
        }
      );
      this.unSubDMList.push(fsDataSub);
    } catch (e) {
      console.error(e);
    }
  }

  getAIApplicationDataModelQueryObject() {
    const version = this.appGlobalService.get('appVersion');
    const queryObjectForSystem = {
      collectionName: `AIImpSchApplicationDataModel_${version}`,
      filter: [
        {
          field: 'aid',
          operator: '==',
          value: this.appGlobalService.get('appId')
        },
        {
          field: 'uploadId',
          operator: '==',
          value: this.uploadId
        }
      ]
    };

    const queryObjectForReverseEngineering = {
      collectionName: `AIImpSchApplicationDataModel_${version}`,
      filter: [
        {
          field: 'aid',
          operator: '==',
          value: this.appGlobalService.get('appId')
        },
        {
          field: 'uploadId',
          operator: '==',
          value: this.uploadId
        }
      ]
    };

    return this.renderInsideModernizeMenu ? queryObjectForReverseEngineering : queryObjectForSystem;
  }

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  getPayloadforFetchingUploadHistoryFromFirebase() {
    const version = this.appGlobalService.get('appVersion');
    const queryObject = {
      collectionName: `AIImpSchUploadHistory_${version}`,
      filter: [
        {
          field: 'appId',
          operator: '==',
          value: this.appGlobalService.get('appId')
        },
        {
          field: 'recDeleted',
          operator: '==',
          value: false
        },
        {
          field: 'active',
          operator: '==',
          value: true
        },
        {
          field: 'generationId',
          operator: '==',
          value: null
        }
      ]
    };

    const queryObjectForReverseEngineering = {
      collectionName: `AIImpSchUploadHistory_${version}`,
      filter: [
        {
          field: 'appId',
          operator: '==',
          value: this.appGlobalService.get('appId')
        },
        {
          field: 'generationId',
          operator: '==',
          value: null // Placeholder, will be replaced later
        },
        {
          field: 'recDeleted',
          operator: '==',
          value: false
        }
        // Active filter commented out as per the original logic
      ]
    };

    return this.store.select(GenerationSelectors.selectGeneration).pipe(
      take(1),
      map((generation) => {
        const generationId = generation?.sid;
        if (this.renderInsideModernizeMenu) {
          queryObjectForReverseEngineering.filter[1].value = generationId;
          return queryObjectForReverseEngineering;
        }
        return queryObject;
      })
    );
  }

  /**
   * Fetches the upload history from Firebase based on the current application version and appId.
   * - If the upload is completed, it triggers the data model fetching process.
   * - If the upload is in progress, it updates the upload progress.
   * - If there is an error during the process, it logs the error and stops the loading state.
   */
  getUploadHistoryFromFireBase() {
    this.isLoading = true;

    try {
      this.eventTracker.start('AIImpSchUploadHistory');
      this.unsubscribeListener(this.unSubHistoryList);
      this.getPayloadforFetchingUploadHistoryFromFirebase().subscribe((queryObject) => {
        const fsDataSub = this.fsService.fireService(queryObject).subscribe(
          (res) => {
            this.isLoading = false;
            this.eventTracker.stop('AIImpSchUploadHistory');
            console.log(`AIImpSchUploadHistory : ${this.eventTracker.trackedEvents.AIImpSchUploadHistory.duration}`);

            if (this.renderInsideModernizeMenu) {
              const sortRecordsByModifiedDate = res.sort((a: any, b: any) => {
                const dateA = a.payload.doc.data().modifiedDate.seconds;
                const dateB = b.payload.doc.data().modifiedDate.seconds;
                return dateA - dateB;
              });
              // In Modernize Menu, we need to consider only the latest record for a particular generationId
              res = sortRecordsByModifiedDate;
            }

            const latestUploadRes = res[res.length - 1];
            if (latestUploadRes && latestUploadRes.type !== 'removed') {
              this.lastestUploadData = latestUploadRes.payload.doc.data();

              if (this.lastestUploadData?.generateDatamodelPercent === 100) {
                if (this.lastestUploadData?.uploadId !== this.uploadId) {
                  this.uploadId = this.lastestUploadData?.uploadId;
                  this.initialCall = true;
                  this.getDataFromFS();
                  if (
                    this.triggerImport &&
                    this.lastestUploadData?.generateDatamodelErrorMsg &&
                    this.lastestUploadData?.generateDatamodelErrorMsg?.length > 1
                  ) {
                    this.errPopup = true;
                  }
                }
                this.aiDataModelGenerationInprogress = false;
                this.isDataModelReadyToMerge = true;
                // Set upload progress to 0 once it is completed
                this.uploadProgress = 0;
                this.isPromptSectionVisible = false;
              } else {
                if (this.isImportDialogVisible) {
                  this.closeImportDialog();
                }
                this.aiDataModelGenerationInprogress = true;
                this.isDataModelReadyToMerge = false;
                // If upload is in progress, update the percentage
                this.uploadProgress = this.lastestUploadData?.generateDatamodelPercent;
                this.importStatus = this.lastestUploadData?.generateDatamodelStage;
                // Close the import dialog once upload starts
              }
            } else {
              this.isUploadActive = false;
              this.isDataModelReadyToMerge = false;
              this.importStatus = 'GEN_IN_PROGRESS';
              if (this.unSubDMList.length) {
                this.unsubscribeListener(this.unSubDMList);
              }
              this.lastestUploadData = null;
              this.uploadId = null;
              this.propertyPaneData = null;
              this.showPropPane = false;
              this.dataModelDataOrder = [];
              this.dataModelCountChange.emit(this.dataModelDataOrder.length);
              this.initTree(this.dataModelDataOrder);
              if (this.intialSchemaLoad) {
                if (!this.dataModelDataOrder.length) {
                  setTimeout(() => {
                    $('#upload-btn')?.trigger('click');
                  }, 100);
                }
                this.intialSchemaLoad = false;
              }
            }
            if (
              this.lastestUploadData &&
              this.lastestUploadData?.generateDatamodelErrorMsg &&
              this.lastestUploadData?.generateDatamodelErrorMsg?.length
            ) {
              this.showLogs = true;
            } else {
              this.showLogs = false;
            }
          },
          (error) => {
            this.isLoading = false;
            console.error(error);
          }
        );
        this.unSubHistoryList.push(fsDataSub);
      });
    } catch (e) {
      console.log(e);
    }
  }

  openErrPopup() {
    this.errPopup = true;
  }

  closeErrPopup() {
    this.errPopup = false;
  }

  unsubscribeListener(subName) {
    this[subName]?.forEach((k) => {
      if (k && typeof k.unsubscribe === 'function') {
        k.unsubscribe();
      }
    });
    this[subName] = [];
  }

  /**
   * To close the dialog
   */
  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  processTree() {
    const tree = $.ui.fancytree.getTree('#schemaTree');
    const d = tree.toDict(true, function (node) {
      if (!node.title) {
        return false;
      }
      return true;
    });
    if (d.title === 'root') {
      if (d.children) {
        this.dataModelDataOrder = [...d.children];
      } else {
        this.dataModelDataOrder = [];
      }
      this.dataModelCountChange.emit(this.dataModelDataOrder.length);
    }
  }

  showVisualizer() {
    this.processTree();
    this.isVisualizerVisible = true;
  }

  hideVisualizer() {
    this.isVisualizerVisible = false;
  }

  toggleVisualizer() {
    if (!this.isVisualizerVisible) {
      this.processTree();
    }
    this.isVisualizerVisible = !this.isVisualizerVisible;
  }

  acceptDataModel() {
    this.allowCreationOfPages = true; // default checked

    this.confirmationDialogService.confirm({
      key: 'acceptAiSuggesstionConfirmation',
      header: this.translate.instant('CONFIRMATION'),
      message: this.translate.instant('GEN_AI_ACCEPT_DATA_MODEL_CONF_MSG'),
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.onAccept();
      },
      reject: () => {
        this.closePopUp();
      }
    });
  }

  onAccept() {
    this.isLoading = true;
    this.store.dispatch(
      acceptAiDataModel({
        apiConstants: ApiConstants.acceptAiDataModel,
        params: {
          orgId: this.orgId,
          appId: this.appId,
          uploadId: this.uploadId,
          createPages: this.allowCreationOfPages
        }
      })
    );
    this.closePopUp();
    this.closeDialog();
  }

  closePopUp() {
    this.acceptConfirmation = false;
  }

  rejectDataModel(confirmationMessageKey?, callback?, ...args) {
    if (this.dataModelDataOrder.length || this.lastestUploadData) {
      this.confirmationDialogService.confirm({
        header: this.translate.instant('CONFIRMATION'),
        message: this.translate.instant(
          confirmationMessageKey ? confirmationMessageKey : 'GEN_AI_REJECT_DATA_MODEL_CONF_MSG'
        ),
        accept: () => {
          this.rejectDataModelImpl(callback, ...args);
        },
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times'
      });
    } else {
      this.rejectDataModelImpl(callback, ...args);
    }
  }

  rejectDataModelImpl(callbackMethod?, ...args) {
    this.isLoading = true;
    if (this.searchTerm) {
      this.clearFilter();
    }
    if (this.isVisualizerVisible) {
      this.hideVisualizer();
    }
    this.store.dispatch(
      rejectAiDataModel({
        apiConstants: ApiConstants.rejectAiDataModel,
        params: {
          appId: this.appId,
          uploadId: this.uploadId
        }
      })
    );

    const rejectDataModelSuccessDataSubs = this.store.select(rejectSuccessData).subscribe((result) => {
      if (result) {
        this.isLoading = false;
        this.showLogs = false;
        this.isVisualizerVisible = false;
        rejectDataModelSuccessDataSubs.unsubscribe();
        this.messageService.clear();
        if (callbackMethod) {
          callbackMethod.call(this, ...args);
        }
      }
    });

    const rejectDataModelFailureDataSubs = this.store.select(rejectFailureData).subscribe((result) => {
      if (result) {
        this.isLoading = false;
        rejectDataModelFailureDataSubs.unsubscribe();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Rejecting Data Model',
          detail: JSON.stringify(result)
        });
      }
    });
  }

  getFileType(fileName: string): string {
    const parts = fileName.split('.');
    return parts[parts.length - 1];
  }

  showErrMsg(data) {
    const sendData = {
      apiErr: data.err,
      tableMap: this.tableMap,
      fieldMap: this.tableFieldMap,
      admData: data.aiDMData
    };
    this.util.showErrMsg(sendData);
  }

  triggerApi(apiCons, payload) {
    this.store.dispatch(
      updateAIDM({
        updApiConstants: apiCons,
        aiDMData: payload
      })
    );
  }

  closeImportDialog() {
    this.selectedFileType = '';
    this.acceptedFileTypes = '';
    this.importDialogHeader = '';
    this.isImportDialogVisible = false;
    this.myfile = [];
  }

  togglePromptSection() {
    if (this.isPromptSectionVisible) {
      this.isPromptSectionVisible = false;
      this.aiGenerationType = null;
    } else {
      this.hideVisualizer();
      this.isImportDialogVisible = false;
      this.isPromptSectionVisible = true;
      this.aiGenerationType = AiGenerationType.PROMPT;
    }
  }

  ngOnInit(): void {
    this.appId = this.appGlobalService.get('appId');
    this.orgId = this.appGlobalService.get('orgId');
    this.tabId = this.appGlobalService.get('tabId');
    this.menuItems = [
      {
        label: this.translate.instant('SQL_UPLOAD_LABEL'),
        icon: 'fa fa-database',
        command: () => {
          this.selectedFileType = 'sql_files';
          this.acceptedFileTypes = '.sql, .txt, .md';
          this.importDialogHeader = 'IMPORT_DIALOG_SQL_HEADER';
          this.isImportDialogVisible = true;
          this.isPromptSectionVisible = false;
          this.aiGenerationType = AiGenerationType.IMPORT;
        }
      },
      {
        label: this.translate.instant('EXCEL_UPLOAD_LABEL'),
        icon: 'pi pi-file-excel',
        command: () => {
          this.selectedFileType = 'excel_files';
          this.acceptedFileTypes = '.xls, .xlsx, .csv';
          this.importDialogHeader = 'IMPORT_DIALOG_EXCEL_HEADER';
          this.isImportDialogVisible = true;
          this.isPromptSectionVisible = false;
          this.aiGenerationType = AiGenerationType.IMPORT;
        }
      },
      {
        label: this.translate.instant('IMAGE_UPLOAD_LABEL'),
        icon: 'pi pi-images',
        command: () => {
          this.selectedFileType = 'image_files';
          this.acceptedFileTypes = '.png, .jpg, .jpeg, .zip, .pdf';
          this.importDialogHeader = 'IMPORT_DIALOG_IMAGE_HEADER';
          this.isImportDialogVisible = true;
          this.isPromptSectionVisible = false;
          this.aiGenerationType = AiGenerationType.IMPORT;
        }
      },
      {
        label: this.translate.instant('DOCUMENT_UPLOAD_LABEL'),
        icon: 'pi pi-file',
        command: () => {
          this.selectedFileType = 'documentation_files';
          this.acceptedFileTypes = '.pdf, .docx';
          this.importDialogHeader = 'IMPORT_DIALOG_DOCUMENT_HEADER';
          this.isImportDialogVisible = true;
          this.isPromptSectionVisible = false;
          this.aiGenerationType = AiGenerationType.IMPORT;
        }
      }
    ];
    this.messageService.clear();
    if (!this.util.checkEditPermission('datamodel')) {
      this.disallowEdit = true;
    }
    const fsLoginInitiatedSub = this.store.select(fsLoginInitiated).subscribe((fsLogin: any) => {
      //console.log("fsLogin " + fsLogin);
      if (fsLogin) {
        this.getUploadHistoryFromFireBase();
      } else {
        this.unsubscribeListener(this.unSubHistoryList);
        this.unsubscribeListener(this.unSubDMList);
      }
    });
    this.addToSubscriptionsList(fsLoginInitiatedSub);
    this.aiGenerationType = this.data?.aiGenerationType || 0;
    // 2 is FIELD generation
    if (this.aiGenerationType === 2) {
      this.pageGenRequired = false;
      this.generateModelForFieldsPrompt();
    } else {
      this.pageGenRequired = true;
    }

    this.metaInfoSub$ = this.store.select(metaInfo).subscribe((res) => {
      this.metaInfoMap = res;
    });

    if (this.renderInsideModernizeMenu) {
      const interimScreensSub = this.store.select(allInterimScreens).subscribe((scs: any) => {
        this.interimScreens = scs || [];
      });
      this.addToSubscriptionsList(interimScreensSub);
    }
  }

  formatBytes(bytes) {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));

    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  }

  removeFile(idx) {
    this.myfile.splice(idx, 1);
  }

  generateModelForTablePrompt() {
    this.pageGenRequired = true;
    if (this.dataModelDataOrder.length) {
      this.rejectDataModel('GEN_AI_REJECT_EXISTING_GENERATION', this.generateModelForTablePromptCore);
    } else {
      this.generateModelForTablePromptCore();
    }
  }

  generateModelForTablePromptCore() {
    this.triggerImport = true;
    this.aiDataModelGenerationInprogress = true;
    this.store.select(GenerationSelectors.selectGeneration).pipe(take(1)).subscribe((generation) => {
      const generationId = generation?.sid;
      this.store.dispatch(
        generateModelForTablePrompt({
          apiConstants: ApiConstants.generateModelForTablePrompt,
          params: {
            appId: this.appId,
            orgId: this.orgId,
            userPrompt: this.promptText,
            tableId: null,
            generationId: generationId
          }
        })
      );

      const sucSub$ = this.store.select(generateModelForTablePromptSuccData).subscribe((result) => {
        if (result) {
          this.aiDataModelGenerationInprogress = false;
          // Backend cleared screen interims and reset PAGE step — sync the frontend store
          if (generationId) {
            this.store.dispatch(ScreenInterimActions.clearScreensInterim());
            this.store.dispatch(GenerationActions.updateStep({
              stepKey: GenerationStepCapitals.PAGE,
              changes: { status: GenerationStepStatus.YET_TO_START }
            }));
          }
          sucSub$.unsubscribe();
        }
      });

      const failSub$ = this.store.select(generateModelForTablePromptFailData).subscribe((result) => {
        if (result) {
          this.aiDataModelGenerationInprogress = false;
          failSub$.unsubscribe();
        }
      });
    });
  }

  generateModelForFieldsPrompt() {
    this.getPayloadforFetchingUploadHistoryFromFirebase().subscribe((queryObject) => {
      const fsDataSub$ = this.fsService.fireService(queryObject).subscribe((res) => {
        if (res.length > 0) {
          this.rejectDataModel('GEN_AI_REJECT_EXISTING_GENERATION', this.generateModelForFieldsPromptCore);
        } else {
          this.generateModelForFieldsPromptCore();
        }
        fsDataSub$.unsubscribe();
      });
    });
  }

  generateModelForFieldsPromptCore() {
    this.pageGenRequired = false;
    this.triggerImport = true;
    this.isLoading = true;
    this.store.dispatch(
      generateModelForFieldPrompt({
        apiConstants: ApiConstants.generateModelForFieldPrompt,
        params: {
          appId: this.appId,
          orgId: this.orgId,
          userPrompt: null,
          tableId: this.data?.tableId
        }
      })
    );

    const sucSub$ = this.store.select(generateModelForFieldPromptSuccData).subscribe((result) => {
      if (result) {
        this.isLoading = false;
        sucSub$.unsubscribe();
      }
    });

    const failSub$ = this.store.select(generateModelForFieldPromptFailData).subscribe((result) => {
      if (result) {
        this.isLoading = false;
        failSub$.unsubscribe();
      }
    });
  }

  regenerateFieldsSchema() {
    if (this.lastestUploadData) {
      this.rejectDataModelImpl(this.generateModelForFieldsPromptCore);
    } else {
      this.generateModelForFieldsPromptCore();
    }
  }

  /**
   * Handle request to update parent table (CREATE/UPDATE/DELETE)
   */
  onRequestParentTableUpdate(event: any) {
    const tree = $.ui.fancytree.getTree('#schemaTree');
    if (!tree) return;

    const tableNode = tree.getNodeByKey(event.tableData?.sid);
    if (!tableNode) return;

    this.isLoading = true;

    const orgId = this.appGlobalService.get('orgId');
    const appId = this.appGlobalService.get('appId');

    const tProps = {
      orgId: orgId,
      aid: appId,
      sid: event.tableData.sid,
      t_pTableId: event.selectedTable?.sid || null,
      t_pTable: event.selectedTable?.name || null,
      old_t_pTable: event.oldParentTable?.name || null,
      name: event.tableData.name,
      old_name: '',
      tabId: this.tabId
    };

    let payload: any = {
      tProps: tProps,
      action: event.action,
      tabId: this.tabId,
      parentTableForeignKey: null
    };
    let nodeObj: any = null;
    let psid: any = null;

    // For CREATE action, create Pid node in tree
    if (event.action === GlobalConstants.create) {
      // Find preNode (last child of table)
      let preNodeId = null;
      if (tableNode.hasChildren()) {
        const children = tableNode.children;
        preNodeId = children[children.length - 1].data?.sid;
      }

      psid = uuidv4();
      const pField = {
        sid: psid,
        name: 'Pid',
        type: nodeType.FIELD,
        f_type: 'String',
        f_tableId: event.tableData.sid,
        f_fieldId: 'pid',
        aid: this.appId,
        orgId: this.orgId,
        tabId: this.tabId,
        preNode: preNodeId,
        pNode: tableNode.data.sid,
        sysGen: true,
        f_sysF: true,
        f_indexed: true,
        f_maxL: 50,
        f_mandatory: 'no',
        f_editing: 'no',
        f_view: 'yes',
        f_hasAnalyticalSync: false,
        f_transientField: false,
        recDeleted: false
      };

      const nodeData = { ...pField, uploadId: this.uploadId };

      // Tree node data
      nodeObj = {
        title: 'Pid',
        type: nodeType.FIELD,
        key: psid,
        folder: false,
        f_sysF: true,
        data: nodeData,
        icon: 'fa pen-field field-icon'
      };

      payload = {
        ...payload,
        pField: pField,
        psid: null
      };
    } else if (event.action === GlobalConstants.delete) {
      payload = {
        ...payload,
        psid: event.pidSid
      };
    }

    // Call API
    const updateSub = this.baseService.put(ApiConstants.updateAiParentTable, payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        // Check for auto references (e.g., screen interim pages referencing the child table)
        const responseBody = response?.body ?? response;
        if (
          responseBody &&
          'errorsAndWarnings' in responseBody &&
          responseBody.errorsAndWarnings?.length > 0
        ) {
          this.showPreValidationModal(responseBody);
          return;
        }
        if (event.action === GlobalConstants.create) {
          // Add to tree
          tableNode.addChildren(nodeObj);
          tableNode.setExpanded(true);
          this.rearrageTreeLegIndicator(50);

          // Update local maps
          if (this.fieldTitles[tableNode.key]) {
            this.fieldTitles[tableNode.key].push('pid');
          } else {
            this.fieldTitles[tableNode.key] = ['pid'];
          }
          this.tableFieldMap = { ...this.tableFieldMap, [psid]: 'Pid' };
          this.tableAndFieldDataMap[tableNode.key]?.fields.push({
            sid: psid,
            name: 'Pid'
          });
        } else if (event.action === GlobalConstants.delete) {
          this.tableAndFieldDataMap[tableNode.key].fields = this.tableAndFieldDataMap[tableNode.key]?.fields || [];
          // Clear parent table from local state after successful delete
          event.tableData.t_pTable = null;
          event.tableData.t_pTableId = null;
          // Remove Pid field from tree
          if (event.pidSid) {
            const pidNode = tableNode.findFirst((n) => n.key === event.pidSid);
            if (pidNode) {
              pidNode.remove();
            }
            // Remove from local maps
            this.tableAndFieldDataMap[tableNode.key].fields =
              (this.tableAndFieldDataMap[tableNode.key]?.fields || []).filter((f) => f.sid !== event.pidSid);
            if (this.fieldTitles[tableNode.key]) {
              this.fieldTitles[tableNode.key] = this.fieldTitles[tableNode.key].filter((f) => f !== 'pid');
            }
          }
        }
        // Update table node data
        tableNode.data = { ...tableNode.data, ...event.tableData };
        tableNode.render();
        // Reassign propertyPaneData reference so the properties pane detects the change
        this.propertyPaneData = { ...tableNode.data };
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error updating parent table:', err);
        this.util.showMessage('error', 'Error updating parent table');

        // Revert parent table to previous state on error
        if (event.action === GlobalConstants.create || event.action === GlobalConstants.update) {
          tableNode.data.t_pTable = event.oldParentTable?.name || null;
          tableNode.data.t_pTableId = event.oldParentTable?.sid || null;
          tableNode.render();
          this.propertyPaneData = { ...tableNode.data };
        }
      }
    });
    this.addToSubscriptionsList(updateSub);
  }

  ngOnDestroy(): void {
    this.zoomElement?.dispose();
    this.unsubscribeListener(this.unSubHistoryList);
    this.unsubscribeListener(this.unSubDMList);
    this.metaInfoSub$.unsubscribe();
    $('#schemaTree').fancytree('destroy');
    $('#schemaTree tr').off('click');
    $('#schemaTree tr').find('#filter').off('keyup');
    $('#schemaTree tr').find('#filter').off('search');
    $('#schemaTree .data-field-type').off();
    $('#schemaTree .data-field-type').remove();
    $('#schemaTree tr').off();
    $('#schemaTree tr').remove();
    $('#schemaTree').remove();
    /* Remove Html element to avoid memory leak.
    Since it is using in Js it will not be garbage collected automatically and will be there in detached dom elements */
    if (this.splitter?.el?.nativeElement) {
      $(this.splitter.el?.nativeElement).remove();
    }
    this.store.dispatch(updateAIDMSuccess({ aiDMSuccData: null }));
    this.store.dispatch(updateAIDMFail({ aiDMFailData: null }));
    this.messageService.clear();
  }
}




